<template>
  <div class="page-shell">
    <PageBanner
      eyebrow="CASES"
      background-image="/page/cases-banner.jpg"
      :title="{ 'zh-CN': '工程案例', 'en-US': 'Project Cases' }"
      :subtitle="{ 'zh-CN': '客户案例展示', 'en-US': 'Customer case presentation' }"
    />

    <section class="section cases-section">
      <div class="container">
        <div class="case-heading">
          <span>PROJECT CASES</span>
<!--          <h2>{{ $pick({ "zh-CN": "工程案例", "en-US": "Project Cases" }) }}</h2>-->
          <p>
            {{ $pick({
              "zh-CN": "覆盖电网、交通、商业综合体、政务建筑与科创园区等典型供配电应用场景。",
              "en-US": "Covering grid, transport, commercial, government-building and science-park power distribution scenarios."
            }) }}
          </p>
        </div>

        <div class="case-grid">
          <router-link
            v-for="item in cases"
            :key="item.slug"
            v-reveal
            class="case-card"
            :to="`/cases/${item.slug}`"
          >
            <figure>
              <img :src="item.image" :alt="$pick(item.title)" />
            </figure>
            <h3>{{ $pick(item.title) }}</h3>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";
import { caseItems } from "../../data/site";

export default {
  name: "CasesPage",
  components: { PageBanner },
  data() {
    return {
      cases: caseItems
    };
  }
};
</script>

<style scoped>
.cases-section {
  background:
    linear-gradient(180deg, rgba(243, 248, 255, 0.85), rgba(255, 255, 255, 0) 260px),
    #fff;
}

.case-heading {
  position: relative;
  margin-bottom: 30px;
  padding-top: 16px;
  border-top: 2px solid #1c78df;
}

.case-heading::before {
  content: "";
  position: absolute;
  top: -2px;
  left: 0;
  width: 270px;
  height: 11px;
  background: linear-gradient(90deg, #0b66d8, #31a9ff);
  clip-path: polygon(0 0, 92% 0, 100% 100%, 0 100%);
}

.case-heading span {
  display: inline-block;
  margin-top: 18px;
  color: var(--brand-blue-soft);
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.case-heading h2 {
  margin: 8px 0 10px;
  color: var(--brand-blue-deep);
  font-size: clamp(30px, 4vw, 44px);
  line-height: 1.15;
}

.case-heading p {
  max-width: 760px;
  margin: 0;
  color: #657284;
  line-height: 1.8;
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 30px 20px;
}

.case-card {
  display: block;
  text-align: center;
}

.case-card figure {
  margin: 0;
  padding: 6px;
  background: #fff;
  border: 1px solid #dfe5ef;
  box-shadow: 0 10px 26px rgba(24, 73, 132, 0.08);
  transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease;
}

.case-card img {
  width: 100%;
  aspect-ratio: 1.28;
  object-fit: cover;
  background: #eef3f8;
}

.case-card h3 {
  margin: 14px 0 0;
  color: #415064;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
}

.case-card:hover figure {
  transform: translateY(-5px);
  border-color: rgba(16, 112, 214, 0.38);
  box-shadow: 0 22px 44px rgba(24, 73, 132, 0.16);
}

.case-card:hover h3 {
  color: var(--brand-blue);
}

@media (max-width: 1100px) {
  .case-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 780px) {
  .case-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px 14px;
  }

  .case-heading::before {
    width: 190px;
  }
}

@media (max-width: 520px) {
  .case-grid {
    grid-template-columns: 1fr;
  }

  .case-card h3 {
    font-size: 17px;
  }
}
</style>
